import { BrowserRouter, Route, Switch } from "react-router-dom";
import Home from "./pages/Home/Home";
import Faq from "./pages/Faq/Faq";
import FormIntegration from "./pages/FormIntegration/FormIntegration";
import FormWebHook from "./pages/FormWebHook/FormWebHook";
import NavbarComp from "./components/NavbarComp";
import Collection from "./pages/Collections/Collection"
import "./style.css";
import Registrativos from "./pages/Registrativos/Registrativos";
import Buscativos from "./pages/Buscativos/Buscativos";
import Capturativos from "./pages/Capturativos/Capturativos";
import Bookvariaveis from "./pages/Bookvariaveis/Bookvariaveis";
import Escrituradora from "./pages/Escrituradora/Escrituradora";


function App() {
  return (
    <>
      <BrowserRouter forceRefresh>
        <NavbarComp />
        <Switch>
          <Route path="/" exact component={Home} />
          <Route path="/faq-support" exact component={Faq} />
          <Route path="/escrituradora" exact component={Escrituradora} />
          <Route path="/capturativos" exact component={Capturativos} />
          <Route path="/buscativos" exact component={Buscativos} />
          <Route path="/registrativos" component={Registrativos} />
          <Route path="/Bookvariaveis" component={Bookvariaveis} />
          <Route path="/integracao-api" component={FormIntegration} />
          <Route path="/integracao-webhook" component={FormWebHook} />
          <Route path="/collection" component={Collection} />
        </Switch>
      </BrowserRouter>
    </>
  );
}

export default App;
